import angular from 'angular';
import apronaRechargeFormComponent from './formComponent';
import apronaRechargeFooterPanelComponent from './footerPanelComponent';

import './recharge.scss';

/**
 * @type {angular.IModule}
 */
export default angular.module('apronaRechargeModule', [
  apronaRechargeFormComponent.name,
  apronaRechargeFooterPanelComponent.name,
]);
